(function () {
  const root = document.getElementById('quick-view')
  if (!root) return
  const box = root.querySelector('.qv-box')
  const slot = root.querySelector('[data-qv-slot]')
  let opener = null

  function open () {
    opener = document.activeElement
    root.classList.add('is-open')
    root.setAttribute('aria-hidden', 'false')
    document.body.classList.add('overflow-hidden')
    box.focus()
    document.addEventListener('keydown', onKey)
  }
  function close () {
    root.classList.remove('is-open')
    root.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('overflow-hidden')
    document.removeEventListener('keydown', onKey)
    slot.innerHTML = '<p class="qv-loading">Loading&hellip;</p>'
    if (opener && opener.focus) opener.focus()
    opener = null
  }
  function onKey (e) {
    if (e.key === 'Escape') {
      close()
      return
    }
    if (e.key !== 'Tab') return
    const focusable = box.querySelectorAll(
      'a[href], button:enabled, select:enabled, textarea:enabled, input:not([type=hidden]):enabled, [tabindex]:not([tabindex^="-"])'
    )
    if (!focusable.length) return
    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault()
      last.focus()
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault()
      first.focus()
    }
  }

  root.querySelectorAll('[data-qv-close]').forEach(function (closeBtn) {
    closeBtn.addEventListener('click', close)
  })

  function addToCart (body, onError) {
    const drawer = document.querySelector('cart-drawer')
    if (drawer && drawer.getSectionsToRender) {
      body.append(
        'sections',
        drawer
          .getSectionsToRender()
          .map(function (node) {
            return node.id
          })
          .join(',')
      )
      body.append('sections_url', window.location.pathname)
    }
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body
    })
      .then(function (response) {
        return response.json()
      })
      .then(function (state) {
        if (state.status) {
          if (onError) onError(state.description || state.message)
          return false
        }
        if (drawer && drawer.renderContents) {
          drawer.renderContents(state)
          drawer.open()
        }
        return true
      })
  }

  function wire () {
    const sel = slot.querySelector('[data-qv-variant]')
    const price = slot.querySelector('[data-qv-price]')
    if (sel && price) {
      sel.addEventListener('change', function () {
        const option = sel.options[sel.selectedIndex]
        if (option && option.dataset.price) price.textContent = option.dataset.price
      })
    }
    slot.querySelectorAll('[data-qv-step]').forEach(function (stepBtn) {
      stepBtn.addEventListener('click', function () {
        const qtyInput = slot.querySelector('[data-qv-qty]')
        qtyInput.value = Math.max(
          1,
          parseInt(qtyInput.value, 10) + parseInt(stepBtn.dataset.qvStep, 10)
        )
      })
    })
    const form = slot.querySelector('form')
    if (!form) return
    form.addEventListener('submit', function (e) {
      e.preventDefault()
      const btn = slot.querySelector('[data-qv-add]')
      const err = slot.querySelector('[data-qv-err]')
      btn.disabled = true
      addToCart(new FormData(form), function (msg) {
        err.hidden = false
        err.textContent = msg
        btn.disabled = false
      })
        .then(function (applied) {
          if (applied) close()
        })
        .catch(function () {
          btn.disabled = false
        })
    })
  }

  document.addEventListener('click', function (e) {
    const chip = e.target.closest('[data-add-variant]')
    if (chip) {
      e.preventDefault()
      const group = chip.closest('.pjs-sizes')
      if (group) group.classList.add('is-busy')
      const body = new FormData()
      body.append('id', chip.dataset.addVariant)
      body.append('quantity', '1')
      addToCart(body, function (msg) {
        const drawer = document.querySelector('cart-drawer')
        if (drawer && drawer.warnVariant) {
          drawer.warnVariant(chip.dataset.addVariant, msg)
          drawer.open()
        }
      })
        .then(function () {
          if (group) group.classList.remove('is-busy')
        })
        .catch(function () {
          if (group) group.classList.remove('is-busy')
        })
      return
    }

    const trigger = e.target.closest('[data-quick-view]')
    if (!trigger) return
    e.preventDefault()
    open()
    /*
       product.url inside a collection already carries ?_pos=&_fid=&_ss=, so appending
       ?section_id= left two question marks, Shopify ignored the parameter and
       returned the whole product page: 419 KB with its header and menu stuffed into
       the popup. It is split at the question mark and only the path is requested.
    */
    const path = trigger.dataset.quickView.split('?')[0]
    fetch(path + '?section_id=quick-view')
      .then(function (response) {
        return response.text()
      })
      .then(function (html) {
        /*
           If a full page ever comes back instead of the section, better to send
           the shopper to the product page than to nest one site inside another.
        */
        if (/<!doctype|shopify-section-header/i.test(html)) {
          window.location.href = path
          return
        }
        slot.innerHTML = html
        wire()
        box.focus()
      })
      .catch(function () {
        slot.innerHTML =
          '<p class="qv-loading">Could not load this one. <a href="' +
          trigger.dataset.quickView +
          '">Open the page instead</a>.</p>'
      })
  })
})()
